export default __webpack_public_path__ + "static/media/sword.8528c19b.glb";